module.exports = __webpack_public_path__ + "img/vol04_character_thumb01.cd142616.png";